import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { GeolocationEventExtraField } from '@/types/api/calendar'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeolocationPresentation',
  props: {
    eventExtraField: null
  },
  setup(__props: any) {

const props = __props as { eventExtraField: GeolocationEventExtraField };



const mapUrl = computed<string>(():string => `https://www.google.com/maps/search/?api=1&query=${props.eventExtraField.lat},${props.eventExtraField.lon}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createTextVNode(_toDisplayString(props.eventExtraField.name), 1),
    _createElementVNode("sup", null, [
      _createElementVNode("a", {
        href: _unref(mapUrl),
        target: "_blank"
      }, "(G)", 8, _hoisted_1)
    ])
  ]))
}
}

})